module.exports = __webpack_public_path__ + "img/virtual_tour.b21b03ec.jpg";